export const DEFAULT_HIGHLIGHT_COLOR = "gold"
export const HIGHLIGHT_COLOR_STORAGE_KEY = "reader-highlight-color"

export function validHighlightColor(palette, color) {
  return Object.hasOwn(palette, color)
}

export function highlightColor(palette, color) {
  return palette[validHighlightColor(palette, color) ? color : DEFAULT_HIGHLIGHT_COLOR]
}

export function readHighlightColor(palette) {
  try {
    const color = window.localStorage.getItem(HIGHLIGHT_COLOR_STORAGE_KEY)
    return validHighlightColor(palette, color) ? color : DEFAULT_HIGHLIGHT_COLOR
  } catch {
    return DEFAULT_HIGHLIGHT_COLOR
  }
}

export function rememberHighlightColor(color) {
  try {
    window.localStorage.setItem(HIGHLIGHT_COLOR_STORAGE_KEY, color)
  } catch {
    // Highlighting still works when browser storage is unavailable.
  }
}

export function selectColorButtons(buttons, selectedColor) {
  buttons.forEach((button) => {
    button.setAttribute("aria-pressed", String(button.dataset.highlightColor === selectedColor))
  })
}
